import React, { useCallback, useContext } from 'react';
import Select, { GroupBase, Props } from 'react-select';
import { AppContext } from '~/AppContext';
import { SimpleCountryFragment } from '~/graphqlTypes/SimpleCountryFragment';

// This pattern advised by https://react-select.com/typescript.
export interface CountriesDropdownProps<
  IsMulti extends boolean = false,
  Group extends GroupBase<SimpleCountryFragment> = GroupBase<SimpleCountryFragment>,
> extends Props<SimpleCountryFragment, IsMulti, Group> {
  /** If false, display countries as "Country Name" instead of "Country Name (CN)" */
  includeCode?: boolean;
}

export function CountriesDropdown<
  IsMulti extends boolean = false,
  Group extends GroupBase<SimpleCountryFragment> = GroupBase<SimpleCountryFragment>,
>( { includeCode = true, ...selectProps }: CountriesDropdownProps<IsMulti, Group> ) {
  const { countries } = useContext( AppContext );

  const getOptionLabel = useCallback(
    ( country: SimpleCountryFragment ) => {
      if ( includeCode && country.name ) {
        return `${country.name.en} (${country.code})`;
      } else {
        return country.name?.en || country.code;
      }
    },
    [includeCode],
  );

  return (
    <Select
      filterOption={ ( { data }, search ) => search === '' || data.code.toLowerCase().includes( search.toLowerCase() ) }
      { ...selectProps }
      options={ countries }
      getOptionLabel={ getOptionLabel }
      getOptionValue={ ( country ) => country.code }
    />
  );
}
